import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, Paper, } from '@material-ui/core';
import clsx from 'clsx';
import { InfoCompPanelHeader, } from '..';
import { useModePanelStyle, } from '../..';
const useStyle = makeStyles(() => {
    return {
        root: {},
        panelContent: {
            height: '100%',
            padding: 0,
        },
    };
}, {
    name: 'GenericPanelComp', index: 1,
});
/**
 * This is a generic component that can be used for creating a component with panel header and body. The provided children will
 * be displayed in the body
 */
export const GenericPanelComp = (props) => {
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    return (_jsxs(Paper, { elevation: 2, className: clsx(panelClasses.root, props.className, classes.root), style: props.style, children: [_jsx(InfoCompPanelHeader, { ...props }), _jsx("div", { className: clsx(panelClasses.panelContent, classes.panelContent, props.panelContentClass), children: props.children })] }));
};
